import * as requestFromServer from '../common/cruds'
import {MyPuchaseSlices} from './slices'
import {callTypes, catchError, endCall, startCall} from '../common/slices'

const actions = MyPuchaseSlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}inspection_companies/subscription/`
const SEAT_PURCHASE_API_URL = `${process.env.REACT_APP_API_BASE_URL}seat-purchases/`
const SUBSCRIPTION_UPGRADE_API_URL = `${process.env.REACT_APP_API_BASE_URL}subscription_plans/upgrade`

export const getMyPurchaseById = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}log/${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.myPurchase(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find purchase"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const resetMyPurchase = () => (dispatch: any) => {
  return dispatch(actions.myPurchase({subscriptionLogDetails: null}))
}

export const purchaseAdditionalSeats = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${SEAT_PURCHASE_API_URL}request`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't purchase additional seats"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const getSeatPurchaseById = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${SEAT_PURCHASE_API_URL}${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.myPurchase({subscriptionLogDetails: response.data.data.seat_purchases}))
    })
    .catch((error) => {
      error.clientMessage = "Can't find seat purchase"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const upgradeSubscriptionPlan = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${SUBSCRIPTION_UPGRADE_API_URL}`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't upgrade subscription plan"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const cancelSubscriptionPlan = (subscriptionPlanId: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .patchRequest(`${process.env.REACT_APP_API_BASE_URL}subscription_plans/${subscriptionPlanId}/cancel`, {})
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't cancel subscription plan"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}